import admissionApi from "./apiSlice";
import { tags } from "Utils/constants";
import { getSchoolId, getUserId } from "Network/utils";

const applicants = admissionApi.injectEndpoints({
  endpoints: (builder) => ({
    getApplicants: builder.query({
      query: ({
        page,
        search,
        sectionId,
        categoryId,
        classId,
        admissionStatus,
      }) => {
        const url = `/applicants/schools/${getSchoolId()}`;

        const params = { sectionId, categoryId, classId, admissionStatus };

        if (page !== undefined) {
          params.page = page;
        }

        if (search !== undefined && search !== "") {
          params.search = search;
        }

        return { url, params };
      },

      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: tags.SCHOOL_APPLICANTS,
                id,
              })),
              { type: tags.SCHOOL_APPLICANTS, id: "LIST" },
            ]
          : [{ type: tags.SCHOOL_APPLICANTS, id: "LIST" }],
    }),

    getApplicant: builder.query({
      query: (id) => ({
        url: `/applicants/${id}`,
      }),
      providesTags: (result, error, id) => [
        { type: tags.SCHOOL_APPLICANTS, id },
      ],
    }),

    applicantsCount: builder.mutation({
      query: (data) => ({
        url: "/applicants/count",
        method: "POST",
        body: {
          ...data,
        },
      }),
    }),

    moveApplicantsToAcademics: builder.mutation({
      query: (data) => ({
        url: "/applicants/move-to-academics",
        method: "POST",
        body: {
          ...data,
          organisationId: getSchoolId(),
        },
      }),
      invalidatesTags: [{ type: tags.SCHOOL_APPLICANTS, id: "LIST" }],
    }),

    createApplicants: builder.mutation({
      query: ({ data, schoolId }) => ({
        url: "/applicants",
        method: "POST",
        body: {
          ...data,
          schoolId: schoolId || getSchoolId(),
        },
      }),
      invalidatesTags: [{ type: tags.SCHOOL_APPLICANTS, id: "LIST" }],
    }),

    editApplicants: builder.mutation({
      query: ({ data, id }) => ({
        url: `/applicants/${id}`,
        method: "PUT",
        body: {
          ...data,
          schoolId: getSchoolId(),
        },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: tags.SCHOOL_APPLICANTS, id: arg._id },
      ],
    }),

    updateApplicantsStatus: builder.mutation({
      query: ({ applicantsIds, status }) => ({
        url: `/applicants/update-status`,
        method: "PUT",
        body: { ids: applicantsIds, action: status },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: tags.SCHOOL_APPLICANTS, id: arg._id },
      ],
    }),

    deleteApplicants: builder.mutation({
      query: ({ id }) => ({
        url: `/applicants/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, arg) => [
        { type: tags.SCHOOL_APPLICANTS, id: arg._id },
      ],
    }),
  }),
});

export const {
  useGetApplicantsQuery,
  useCreateApplicantsMutation,
  useUpdateApplicantsStatusMutation,
  useDeleteApplicantsMutation,
  useEditApplicantsMutation,
  useGetApplicantQuery,
  useApplicantsCountMutation,
  useMoveApplicantsToAcademicsMutation,
} = applicants;
